import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

const MUTATION = gql`
  mutation addAllToCart($request: [CartItemRequest]!) {
    addAllToCart(request: $request) {
      id
      count
      items {
        product {
          id
          name
          sku
          attributes {
            code
            value
          }
          variants {
            type
            name
            price
          }
          media {
            type
            url
          }
        }
        price
        quantity
        format
      }
      totals {
        subtotal
      }
      relatedProducts {
        id
        sku
      }
    }
  }
`;

interface ProductAttribute {
  code: string;
  value: string;
}

interface AddRequest {
  productId: string;
  quantity: number;
  format: string;
  productAttributes?: ProductAttribute[];
}

type AddMutation = (requests: AddRequest[]) => void;

interface AddArgs {
  onCompleted?: (data) => void;
}

const useAddAllToCart = ({ onCompleted }: AddArgs = {}): AddMutation => {
  const [add] = useMutation(MUTATION, { onCompleted });
  return (request: AddRequest[]) =>
    add({
      variables: { request },
    });
};

export default useAddAllToCart;
